module.exports = __webpack_public_path__ + "img/happytogether_main_02.55a3a037.jpg";